import {
  getCheckoutFormValues,
  setSectionVisibilityHelper,
} from 'app/services/businessFunctionHelpers';
import { FormsEnum, SectionsEnum } from 'app/shared/enums';

const setupInsurantAddress = {
  setupInsurantAddress() {
    const { correspondenceAddress } = getCheckoutFormValues().checkout.insurant;

    const isDifferentCorrespondenceAddress =
      correspondenceAddress === 'different';

    setSectionVisibilityHelper({
      key: SectionsEnum.CheckoutSectionInsurant3,
      formName: FormsEnum.CheckoutForm,
      visible: isDifferentCorrespondenceAddress,
    });

    setSectionVisibilityHelper({
      key: SectionsEnum.CheckoutSectionInsurant32,
      formName: FormsEnum.CheckoutForm,
      visible: isDifferentCorrespondenceAddress,
    });
  },
};

export default setupInsurantAddress;
